<template>
  <v-navigation-drawer v-model="drawer" :mini-variant="mini" permanent app>
    <v-list dense>
      <v-list-item link @click.stop="mini = !mini">
        <v-list-item-icon>
          <v-icon v-if="mini">mdi-menu</v-icon>
          <v-icon v-else>mdi-chevron-left</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>メニュー</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <div v-for="(item, itemIndex) in items" :key="itemIndex">
        <div v-for="si in item.subitems" :key="si.key">
          <v-list-item
            v-if="si.isShow ? si.isShow() === true : true"
            link
            @click="si.onclick"
            :input-value="
              selectedRisk.title === si.title || (si.isOn && si.isOn() === true)
            "
            active-class="active"
          >
            <v-list-item-icon>
              <v-tooltip right z-index="3000">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">{{ si.icon }}</v-icon>
                </template>
                <span>{{ si.title }}</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ si.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <v-divider />
      </div>
    </v-list>
    <v-dialog v-model="usingDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-4">
          利用における注意事項
        </v-card-title>
        <v-card-text class="pt-3">
          &emsp;本システムで提供する観測情報は、無人観測所から送られてくるデータをただちにお知らせする目的で作られています。
          そのため、観測機器の故障や通信異常等による異常データがそのまま表示されてしまう可能性がありますのでご注意ください。
        </v-card-text>
        <v-card-text>
          &emsp;本情報の利用により発生した損害について、町では一切の責任を負いかねますので、ご了承ください。
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="usingDialog = false">
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { Risk } from "../enums/Risk";
import { BRANCH_OFFICE } from "../enums/BranchOffice";
import * as cognito from "../utils/cognito";
export default {
  name: "NavigationDrawer",
  data() {
    return {
      drawer: true,
      mini: true,
      usingDialog: false,
      chronologyWindow: null,
      items: [
        {
          subitems: [
            {
              key: "home",
              icon: "mdi-home-map-marker",
              title: "ホーム",
              onclick: () => {
                this.$store.commit("SET_IS_CAMERA_MONITOR", false);
                this.$store.commit("SET_MAP_DETAIL", { isShowing: false });
                this.$store.commit("SET_IS_RIGHT_NAV", true);
                this.$store.commit("SET_IS_MONITORING", true);
                if (this.map) {
                  this.map.panTo([BRANCH_OFFICE[0].lat, BRANCH_OFFICE[0].lng]);
                  setTimeout(() => {
                    this.map.setZoom(12);
                  }, 800);
                }
              }
            },
            {
              key: Risk.RAIN.key,
              icon: Risk.RAIN.icon,
              title: Risk.RAIN.title,
              onclick: () => this.$store.commit("SET_SELECTED_RISK", Risk.RAIN)
            },
            {
              key: Risk.SNOW.key,
              icon: Risk.SNOW.icon,
              title: Risk.SNOW.title,
              onclick: () => this.$store.commit("SET_SELECTED_RISK", Risk.SNOW)
            },
            {
              key: Risk.DOSYA.key,
              icon: Risk.DOSYA.icon,
              title: Risk.DOSYA.title,
              onclick: () => this.$store.commit("SET_SELECTED_RISK", Risk.DOSYA)
            },
            {
              key: Risk.KOUZUI.key,
              icon: Risk.KOUZUI.icon,
              title: Risk.KOUZUI.title,
              onclick: () =>
                this.$store.commit("SET_SELECTED_RISK", Risk.KOUZUI)
            }
          ]
        },
        {
          subitems: [
            {
              icon: "mdi-table-large",
              title: "河川・降雨情報一覧",
              onclick: () => {
                const routeData = this.$router.resolve({
                  name: "ObservatoryList"
                });
                window.open(routeData.href, "_blank");
              }
            },
            {
              icon: "mdi-table-large",
              title: "降雪情報一覧",
              onclick: () => {
                const routeData = this.$router.resolve({
                  name: "SnowObservatoryList"
                });
                window.open(routeData.href, "_blank");
              }
            },
            {
              icon: Risk.TYPHOON.icon,
              title: Risk.TYPHOON.title,
              onclick: () => window.open(Risk.TYPHOON.url)
            },
            {
              icon: Risk.HAZARD.icon,
              title: Risk.HAZARD.title,
              onclick: () => window.open(Risk.HAZARD.url)
            },
            {
              icon: Risk.BOUSAI_POTAL.icon,
              title: Risk.BOUSAI_POTAL.title,
              onclick: () => window.open(Risk.BOUSAI_POTAL.url)
            }
          ]
        },
        {
          subitems: [
            {
              icon: "mdi-weather-partly-cloudy",
              title: "天気予報",
              isShow: () => this.isPrivate,
              isOn: () => this.$store.getters.isWeather,
              onclick: () => {
                const bool = !this.$store.getters.isWeather;
                this.$store.commit("SET_IS_WEATHER", bool);
                if (bool === true) {
                  this.$store.commit("SET_IS_MONITORING", false);
                  this.$store.commit("SET_IS_CAMERA_MONITOR", false);
                }
              }
            },
            {
              icon: "mdi-monitor-eye",
              title: "水位・雨量モニタ",
              isOn: () => this.$store.getters.isMonitoring,
              onclick: () => {
                const bool = !this.$store.getters.isMonitoring;
                this.$store.commit("SET_IS_MONITORING", bool);
                if (bool === true) {
                  this.$store.commit("SET_IS_WEATHER", false);
                  this.$store.commit("SET_IS_CAMERA_MONITOR", false);
                }
              }
            },
            {
              icon: "mdi-monitor-dashboard",
              title: "カメラ一覧",
              isOn: () => this.$store.getters.isCameraMonitor,
              onclick: () => {
                const bool = !this.$store.getters.isCameraMonitor;
                this.$store.commit("SET_IS_CAMERA_MONITOR", bool);
                if (bool === true) {
                  this.$store.commit("SET_IS_WEATHER", false);
                  this.$store.commit("SET_IS_MONITORING", false);
                  this.$store.commit("SET_IS_RIGHT_NAV", false);
                }
              }
            },
            {
              icon: "mdi-message-bulleted",
              title: "お知らせ",
              isOn: () => this.$store.getters.isRightNavVisible,
              onclick: () => {
                if (this.$store.getters.isShowMapDetail === true) {
                  this.$store.commit("SET_MAP_DETAIL", { isShowing: false });
                  this.$store.commit("SET_IS_RIGHT_NAV", true);
                } else {
                  const bool = !this.$store.getters.isRightNavVisible;
                  this.$store.commit("SET_IS_RIGHT_NAV", bool);
                  if (bool === true) {
                    this.$store.commit("SET_IS_CAMERA_MONITOR", false);
                  }
                }
              }
            },
            {
              icon: "mdi-clipboard-text-clock",
              title: "クロノロジー",
              isShow: () => this.isPrivate,
              isOn: () => this.$store.getters.isChronology,
              onclick: () => {
                if (this.$store.getters.isChronology === true) {
                  this.$store.commit("SET_IS_CHRONOLOGY", false);
                } else {
                  this.$store.commit("SET_IS_MONITORING", false);
                  this.$store.commit("SET_MAP_DETAIL", { isShowing: false });
                  this.$store.commit("SET_IS_RIGHT_NAV", false);
                  this.$store.commit("SET_IS_CAMERA_MONITOR", false);
                  this.$store.commit("SET_IS_CHRONOLOGY", true);
                }
              }
            },
            {
              icon: "mdi-clipboard-text-clock",
              title: "クロノロジー(全画面)",
              isShow: () => this.isPrivate,
              onclick: () => {
                const routeData = this.$router.resolve({
                  name: "ScreenChronology"
                });
                if (
                  this.chronologyWindow &&
                  this.chronologyWindow.closed === false
                ) {
                  this.chronologyWindow.focus();
                } else {
                  this.chronologyWindow = window.open(routeData.href, "_blank");
                }
              }
            }
          ]
        },
        {
          subitems: [
            {
              icon: "mdi-alert-outline",
              title: "ご利用に際して",
              onclick: () => {
                this.usingDialog = true;
              }
            }
          ]
        }
      ]
    };
  },
  computed: {
    selectedRisk() {
      return this.$store.getters.selectedRisk;
    },
    map() {
      return this.$store.getters.leafletMap;
    },
    isPrivate() {
      return process.env.VUE_APP_MODE === "private";
    },
    isManager() {
      if (!this.$store.getters.user["cognito:groups"]) {
        return;
      }
      return this.$store.getters.user["cognito:groups"].includes("manager");
    }
  },
  mounted() {
    if (this.isPrivate) {
      const subitems = [];
      if (this.isManager) {
        subitems.push({
          icon: "mdi-account-cog",
          title: "ユーザ管理",
          onclick: () => {
            this.$router.push("/user-dashboard");
          }
        });
      }
      subitems.push({
        icon: "mdi-exit-to-app",
        title: "ログアウト",
        onclick: async () => {
          cognito.signout();
          await this.$store.dispatch("REFRESH_SERVICE_WORKER_REGISTRATION");
          window.location.reload(true);
        }
      });
      this.items.push({
        subitems: subitems
      });
    }
  }
};
</script>
<style>
.active {
  color: #3a1e87 !important;
}

.v-list .active,
.v-list .active .v-icon {
  color: inherit;
}
</style>
